document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('rental-info-container');
  if (!container) return;

  const barcode = container.dataset.barcode;
  const locale = container.dataset.locale || 'de';
  const source = container.dataset.source || 'academy';
  const customParams = container.dataset.customParams || 'view=academy';

  if (!barcode) {
    container.remove();
    return;
  }

  fetch('https://checkout.api.circuly.io/v1/online-resellers/qKpqcIU33sRxNU79e4E264BLq7k968/generate-visual', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      barcode,
      locale,
      source,
      custom_params: customParams
    })
  })
  .then(response => {
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return response.text();
  })
  .then(html => {
    if (!html.trim()) {
      container.remove();
      return;
    }

    container.innerHTML = html;
  })
  .catch(error => {
    console.error('Error fetching rental info:', error);
    container.remove();
  });
});
